module.exports = __webpack_public_path__ + "static/img/pls@3x.ad8f6e65.png";